/**
 * wtshuang@cs.uw.edu
 * 2018/01/12
 * The class for the answers
 */

import { Token, Performance } from './Interfaces';
import { utils } from 'src/stores/Utils';

export class Answer {
    public model: string; // which model generated this answer
    public qid: string; // question id    
    public vid: number; // version id
    public sid: number; // the sentence id
    public isGroundtruth: boolean; // is the ground truth by default
    public span_start: number; // the span idx of the first token in answer.
    public span_end: number; // the span idx of the last token in answer.
    public doc: Token[]; // editing type
    public perform: Performance<number>;

    constructor (model: string, qid: string, sid: number,
                 isGroundtruth: boolean, span_start: number, span_end: number,
                 doc: Token[], perform: Performance<number>) {
        this.model = model;
        this.qid = qid;
        this.sid = sid;
        this.isGroundtruth = isGroundtruth;
        this.span_start = span_start;
        this.span_end = span_end;
        this.doc = doc;
        this.perform = perform;
    }

    /**
     * Get the color
     */
    public getColorDark (): string {
        if (this.isGroundtruth) {
            return utils.answerColor.groundtruth.dark
        } else if (this.perform.f1 <= 0.5) {
            return utils.answerColor.incorrect.dark
        } else {
            return utils.answerColor.correct.dark
        }
    }

    public getColorShallow (): string {
        if (this.isGroundtruth) {
            return utils.answerColor.groundtruth.light
        } else if (this.perform.f1 <= 0.5) {
            return utils.answerColor.incorrect.light
        } else {
            return utils.answerColor.correct.light
        }
    }


    /**
     * Make the instances into raw text
     * @return plain text of the instance.
     */
    public textize(): string {
        let text: string = '';
        this.doc.forEach((d: Token) => { text += d.text + d.whitespace; });
        return text;
    }
}



// WEBPACK FOOTER //
// ./src/stores/Answer.ts